import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useObjetivos } from "../../../../context/SuperAdmin/OASContexts/ObjetivosContext";
import { iDataObjetivo } from "../../../../interfaces/SuperAdmin/Pages/iDataObjetivos";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";

interface Props {
  objetivo: iDataObjetivo;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const ObjetivosRow: React.FC<Props> = ({
  objetivo,
  i,
  isSelected,
  handleSelect,
}) => {
  const { nombre, created_at } = objetivo;
  const { handleEditObjetivo } = useObjetivos();
  const navigate = useNavigate();

  const handleNavigate = (idObjetivo: string) => {
    navigate(`${idObjetivo}`);
  };

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(objetivo.id_objetivo)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center", maxWidth: 400 }}>
        {nombre}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {formatFechaWithHour(created_at)}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleEditObjetivo(objetivo)}
        >
          <Tooltip title="Editar objetivo">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleNavigate(objetivo.id_objetivo)}
        >
          <Tooltip title="Ver objetivo">
            <IconButton aria-label="objetivo" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
